module.exports = __webpack_public_path__ + "static/img/sger.b5a327b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sger.png
// module id = SIN3
// module chunks = 0